import { useAppContext } from '@common/contexts/AppContext';
import { getGuestOrder, getUnauthenticatedOrder } from './requests';
import { useQuery } from '@tanstack/react-query';

export const accountKeys = {
  account: ['account'] as const,
  guestOrder: (params: { guestId: number; orderId: number; siteId: number }) =>
    [...accountKeys.account, 'guest-order', params] as const,
  getUnauthenticatedOrder: (params: { propertyId: string; orderId: string }) =>
    [...accountKeys.account, 'guest-order', params] as const,
};

export function useGuestOrder({ guestId, orderId }: { guestId: number; orderId: number }) {
  const { siteId } = useAppContext();

  return useQuery({
    queryKey: accountKeys.guestOrder({ guestId, orderId, siteId }),
    queryFn: () => getGuestOrder({ guestId, orderId, siteId }),
  });
}

export function useGetUnauthenticatedOrder({
  propertyId,
  orderId,
}: {
  propertyId: string;
  orderId: string;
}) {
  return useQuery({
    queryKey: accountKeys.getUnauthenticatedOrder({ propertyId, orderId }),
    queryFn: () => getUnauthenticatedOrder({ propertyId, orderId }),
  });
}
